import {h, Fragment} from "preact"
import { useActions } from '@nosto/preact'
import { facetNameTranslations, isFrench } from '../config'

export default ({ facet }) => {
    const { toggleProductFilter } = useActions();

    const handleFacetClick = (event, value) => {
        event.preventDefault();
        if(window.innerWidth >= 1024 && window.document.querySelector('.ns-serp')) {
            window.scrollTo({ 
                top: window.document.querySelector('.ns-serp').getBoundingClientRect().top - window.document.body.getBoundingClientRect().top - 74,
                behavior: "smooth"
            })
        }
        // setTimeout(() => {
            toggleProductFilter(
                facet.field,
                value.value,
                !value.selected
            )
        // }, 100)
    }

    return (
        <li class="ns-sidebar-dropdown">
            <div class="ns-facet-title">
                {isFrench ? facetNameTranslations[facet.name] : facet.name}
            </div>
            <div class="ns-sidebar-submenu">
                <ul class="ns-facet-list flex flex-col ns-list-unstyled">
                    {facet.data?.map((value) => (
                        <li class="">
                            <label class="ns-checkbox flex">
                                <input
                                    type="checkbox"
                                    checked={value.selected}
                                    onChange={(event) => handleFacetClick(event, value)}
                                />
                                <span class="ns-checkmark"></span>
                                {value.value}
                            </label>
                            {/* <span class="">{value.count}</span> */}
                        </li>
                    ))}
                </ul>
            </div>
        </li>
    )
}